import React from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { SOCKET_URL, setupInterceptorsTo } from 'src/apiHelper/helper.js'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import { randomString } from '../../../utils/sharedFunctions'
import { toast } from 'react-toastify'
import { AllowedFormats } from '../../../utils/sharedAttachmentFunctions'

const socketApi = setupInterceptorsTo(
  axios.create({
    baseURL: SOCKET_URL,
  }),
)

const MessageFileUpload = ({ files, setFiles, fileInput }) => {
  const selectedProvider = useSelector((state) => state.user?.provider)

  const uploadImage = (file) => {
    const reader = new FileReader()
    let fileExt = file?.name?.split('.')?.pop()
    let fileName =
      selectedProvider?._id + '_' + new Date().getTime() + randomString(6) + '.' + fileExt
    if (AllowedFormats.indexOf(fileExt) === -1) {
      toast.error('File type is not supported.')
    } else {
      reader.readAsDataURL(file)
      reader.onloadend = async (e) => {
        let cameraImage = {
          key: fileName,
          size: file.size,
          file_type: fileExt,
          checksum: null,
          file: { ...file, name: fileName },
          img: reader.result,
          //TODO
          status: 'uploading',
        }

        setFiles([...files, cameraImage])

        let formData = new FormData()
        formData.append('file', file)
        formData.append('fileName', fileName)
        formData.append('filedate', format(new Date(), 'MM/dd/yyyy'))

        const response = await socketApi.post('/conversations/upload/file', formData)

        if (response?.data?.status === 'success') {
          setFiles([...files, { ...cameraImage, status: 'uploaded', message_type: 2 }])
        } else {
          toast.error('Upload failed, please try again.')
        }
      }
    }
  }

  const handleOnDragOver = (e) => {
    e.preventDefault()
  }

  const handleOnDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    let file = e.dataTransfer?.files[0]
    uploadImage(file)
  }

  return (
    <div onDragOver={handleOnDragOver} onDrop={handleOnDrop}>
      <>
        <div>
          <input
            accept="*"
            type="file"
            ref={fileInput}
            onChange={(e) => uploadImage(e.target?.files[0])}
            hidden
            id="input-file"
            onClick={(event) => {
              event.target.value = null
            }}
          />
        </div>
      </>
    </div>
  )
}

MessageFileUpload.propTypes = {
  files: PropTypes.array,
  setFiles: PropTypes.func,
  fileInput: PropTypes.any,
}

export default MessageFileUpload
